import React from "react"
import { observer } from "mobx-react-lite"
import { useStores } from "../../models"
import styled from '~/ui/styled'
import { ActivityIndicator } from "~/ui/primitives"
import { CenterFlex } from "~components/El"

const Container = styled(CenterFlex)`
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
`

interface Props {}

const HomeHeader: React.FC<Props> = () => {
  return (
    <Container>
      <Title />
    </Container>
  )
}

const TitleText = styled.Text`
  font-size: ${({ theme }) => theme.fontSizes.xl};
`

const Row = styled(CenterFlex)`
  flex-direction: row;
`
const Title = observer(() => {
  const { websocketStore, messageStore } = useStores()
  let title
  if (websocketStore.ready) {
    title = `聊天` + (messageStore.unread > 100 ? '(99+)' : messageStore.unread > 0 ? `(${messageStore.unread})` : "")
  } else {
    title = websocketStore.stateText + (websocketStore.loading ? "..." : "")
  }
  return (
    <Row>
      {websocketStore.loading ? <ActivityIndicator size={"small"} color="#999" /> : null}
      <TitleText>{title}</TitleText>
    </Row>
  )
})

export default observer(HomeHeader)
